export function myQaQuestionListGet(page) {
	return {
    type: 'MY_QA_QUESTION_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export function myQaQuestionItemGet(qaId, callback) {
	return {
    type: 'MY_QA_QUESTION_ITEM_GET',
		payload: {
			qaId: qaId,
		},
		callback: callback,
	}
}

export function myQaQuestionSave(payload, callback) {
	return {
    type: 'MY_QA_QUESTION_SAVE',
		payload: payload,
		callback: callback,
	}
}

export function myQaQuestionItemDel(qaId) {
	return {
    type: 'MY_QA_QUESTION_ITEM_DEL',
		payload: {
			qaId: qaId,
		},
	}
}


export function myQaQuestionStatisticsGet(qaId) {
	return {
		type: "MY_QA_QUESTION_STATISTICS_GET",
		payload: {
			qaId: qaId,
		},
	}
}

export function myQaQuestionStatisticsDel(qaId) {
	return {
		type: "MY_QA_QUESTION_STATISTICS_SET",
		payload: {
			type: 'del',
			qaId: qaId,
		},
	}
}

export function myQaQuestionStatisticsUserGet(qaId, answerText, page, callback) {
	return {
		type: "MY_QA_QUESTION_STATISTICS_USER_GET",
		payload: {
			qaId: qaId,
			answerText: answerText,
			page: page,
		},
		callback: callback,
	}
}
